// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"46e73cb7","168":"d46c3535","282":"2057d43d","614":"67bf29fd","773":"1fc1f79d","896":"1be25ab4"}[chunkId] + ".chunk.js";
};